import { SupportModuleState } from "../store/SupportModuleState";
import * as actions from "./actions";

/**
 * The Support Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function supportReducer(state: SupportModuleState = new SupportModuleState(), action: IReduxAction) {
    switch (action.type) {
        case actions.SUPPORT_USERS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                userSearchFilters: {}
            });
        case actions.SUPPORT_USERS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                userSearchFilters: action.payload
            });
        case actions.SUPPORT_DEALERS_SEARCH_CLEAR_FILTERS:
            return Object.assign({}, state, {
                dealerSearchFilters: {}
            });
        case actions.SUPPORT_DEALERS_SEARCH_UPDATE_FILTERS:
            return Object.assign({}, state, {
                dealerSearchFilters: action.payload
            });
        default:
            return state;
    }
}
